<template>
  <div class="register">
      <div class="back">
          <div class="div-center">
              <div class="content">
                  <h3>Register</h3>
                  <hr />
                  <form>
                      <div class="form-group">
                          <label for="email">Email address</label>
                          <input type="email" class="form-control" id="email" v-model="email" placeholder="Email">
                      </div>
                      <div class="form-group">
                          <label for="password">Password</label>
                          <input type="password" class="form-control" id="password" v-model="password" placeholder="Password">
                      </div>
                      <div class="form-group">
                          <label for="confirm-password">Confirm Password</label>
                          <input type="password" class="form-control" id="confirm-password" v-model="password2" placeholder="Confirm Password">
                      </div>
                      <br>
                      <button type="button" class="btn btn-primary" @click="register">Register</button><div class="error">{{errorMessage}}</div>
                      <hr/>
                      <router-link class="nav-link" to="login">Login</router-link>
                   
                  </form>
              </div>                   
          </div>
      </div> 
  </div>
</template>
<script>

export default {
  name: "Register",
  components: { 
  },
  props: {
  },
  data() {
    return {
        token: '',
        email: '',
        password: '',
        password2: '',
        errorMessage: ''  
    };
  },
  created: function() {
    localStorage.clear();
    this.token = this.$route.query.code;
    this.email = this.$route.query.email;
  },
  methods: {
      register: function() {
        this.errorMessage = '';       
        this.$http.post(this.apiUrl + 'users/register', { Token: this.token, Email: this.email, Password: this.password, Password2: this.password2 })
            .then((response) => {
                localStorage.clear();
                localStorage.setItem('userEmail', this.email);       
                this.$router.push('login');
            }, 
            (error) => {
                switch(error.response.status) {
                    case 404:
                        this.errorMessage = 'No user found with that email address';
                        break;
                    default:
                        this.errorMessage = 'Error';
                }
            });
      }
  }
};
</script>
<style scoped>
     th, td {
        text-align: left
    }

    .back {
        background: #e2e2e2;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0
    }

    .div-center {
        width: 400px;
        height: 400px;
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;
        padding: 1em 2em;
        border-bottom: 2px solid #ccc;
        display: table;
    }

    div.content {
        display: table-cell;
        vertical-align: middle;
    }

    div.error {
        color: red;
        display: inline;
        padding-left: 15px;
    }       
</style>
